import Vue from 'vue'
import http from '../utils/http';

export default {
    state: {
        segments: [],
        market_segments: [],
        /*segment constants*/
        DOMINANT_GENDER: [
            {   text_en: 'male',
                text_ro: 'masculin',
                text_ru: 'мужской',
                value: 'male'}, 
            {   text_en: 'female',
                text_ro: 'feminin',
                text_ru: 'женский',
                value: 'female'}, 
            {   text_en: 'any',
                text_ro: 'oricare',
                text_ru: 'любой',
                value: 'any'}
        ],
        INCOME_RANGE: [
            {   text_en: 'low',
                text_ro: 'scăzut',
                text_ru: 'низкий',
                value: 'low'
            },
            {   text_en: 'lower medium',
                text_ro: 'mediu inferior',
                text_ru: 'ниже среднего',
                value: 'lower medium'
            },
            {   text_en: 'medium',
                text_ro: 'mediu',
                text_ru: 'средний',
                value: 'medium'
            },
            {   text_en: 'upper medium',
                text_ro: 'mediu-superior',
                text_ru: 'выше среднего',
                value: 'upper medium'
            },
            {   text_en: 'high',
                text_ro: 'ridicat',
                text_ru: 'высокий',
                value: 'high'
            },
            {   text_en: 'any',
                text_ro: 'orice',
                text_ru: 'любой',
                value: 'any'
            }
        ],
        EDUCATION: [
            {   text_en: 'secondary school',
                text_ro: 'școala generală',
                text_ru: 'средняя школа',
                value: 'secondary school'
            }, 
            {   text_en: 'professional school',
                text_ro: 'școală profesională',
                text_ru: 'профессиональное училище',
                value: 'professional school'
            }, 
            {   text_en: 'bachelor',
                text_ro: 'licențiat',
                text_ru: 'бакалавриат',
                value: 'bachelor'
            }, 
            {   text_en: 'masters',
                text_ro: 'masterat',
                text_ru: 'магистратура',
                value: 'masters'
            }, 
            {   text_en: 'any',
                text_ro: 'oricare',
                text_ru: 'любой',
                value: 'any'
            }
        ],
        CIVIL_STATUS: [
            {   text_en: 'single',
                text_ro: 'singur',
                text_ru: 'холостой',    
                value: 'single'
            }, 
            {   text_en: 'single with children',
                text_ro: 'persoană singură cu copii',
                text_ru: 'одинокий родитель',
                value: 'single with children'
            }, 
            {   text_en: 'married, no children',
                text_ro: 'căsătorit, fără copii',
                text_ru: 'женат, детей нет',
                value: 'married, no children'
            }, 
            {   text_en: 'married with children',
                text_ro: 'căsătorit, cu copii',
                text_ru: 'женат, c детьми',
                value: 'married with children'
            }, 
            {   text_en: 'any',
                text_ro: 'oricare',
                text_ru: 'любой',
                value: 'any'
            }
        ],
        WORKPLACE: [
            {   text_en: 'self-employed',
                text_ro: 'lucrător independent',
                text_ru: 'самозанятый',
                value: 'self-employed'
            },
            {   text_en: 'field employee',
                text_ro: 'angajat de teren',
                text_ru: 'выездной сотрудник',
                value: 'field employee'
            },
            {   text_en: 'office employee',
                text_ro: 'angajat de birou',
                text_ru: 'офисный работник',
                value: 'office employee'
            },
            {   text_en: 'entrepreneur',
                text_ro: 'antreprenor',
                text_ru: 'предприниматель',
                value: 'entrepreneur'
            },
            {   text_en: 'unemployed',
                text_ro: 'șomer',
                text_ru: 'безработный',
                value: 'unemployed'
            },
            {   text_en: 'any',
                text_ro: 'oricare',
                text_ru: 'любой',
                value: 'any'
            }
        ],
        LIFESTYLE: [
            {   text_en: 'active',
                text_ro: 'activ',
                text_ru: 'активный',
                value: 'active'
            },
            {   text_en: 'relaxed',
                text_ro: 'relaxat',
                text_ru: 'расслабленный',
                value: 'relaxed'
            },
            {   text_en: 'balanced',
                text_ro: 'echilibrat',
                text_ru: 'сбалансированный',
                value: 'balanced'
            },
            {   text_en: 'any',
                text_ro: 'oricare',
                text_ru: 'любой',
                value: 'any'
            }
        ]

    },
    mutations: {
        loadSegments(state, payload) {
			state.segments = payload
		},
        loadMarketSegments(state, payload) {
			state.market_segments = payload
		},
        addSegment(state, payload) {
           const index = state.market_segments.length
			Vue.set(state.market_segments, index, payload)   
        },
        editSegment(state, payload) {
            const seg = state.market_segments.find(s => s.id == payload.market_segment_id)
            if (seg) {
                delete payload.market_segment_id;
                const index = state.market_segments.indexOf(seg)
                seg.segment = payload;
                Vue.set(state.market_segments, index, seg)
            }
               
        },
        editMarketSegment(state, payload) {
            const seg = state.market_segments.find(s => s.id == payload.id)
            if (seg) {
                const index = state.market_segments.indexOf(seg)
                Vue.set(state.market_segments, index, {...seg, ...payload})
            }
               
        },
        deleteSegment(state, payload) {
            state.segments =  state.segments.filter(s => s.id !== payload)
        },
        deleteMarketSegment(state, payload) {
            state.market_segments =  state.market_segments.filter(s => s.id !== payload)
        }
    },
    actions: {
        async fetchSegments({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            //payload = segment.category == set.item
            try {
                const result = await http.get(`/segment/${ payload }`);
                //console.log(result)
                if (result) {
                   const segments = await result.data 
                   commit('loadSegments', segments)
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async fetchMarketSegments({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            const game_id = payload.gameId;
            const round = payload.round;

            try {
                const result = await http.get(`/market-segment/${ game_id }?round=${round}`);
                //console.log(result)
                if (result) {
                   const segments = await result.data 
                   commit('loadMarketSegments', segments)
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        //adding segment + market-segment
        async addSegment({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            console.log(payload)

            try {
                const result = await http.post(`/segment`, payload[0]);
                //console.log(result)
                if (result && result.data && result.data.id) {
                    payload[1].segmentId = result.data.id;
                    
                    const res = await http.post(`/market-segment`, payload[1])
                    console.log(res)
                    const segment = await res.data
                    segment.segment = result.data;
                    //console.log(segment)
                    commit('addSegment', segment)
                }                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        //segment parameters updating
        async editSegment({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            
            const market_segment_id = payload.id;
            const id = payload.segmentId;
            delete payload.id;
            delete payload.segmentId;

            try {
                await http.put(`/segment/${id}`, payload);

                payload.id = id;
                payload.market_segment_id = market_segment_id;
                
                commit('editSegment', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async editMarketSegment({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            console.log(payload)

            let segment = {}

            if (payload.segment) {
                segment = payload.segment;
                delete payload.segment;
            }

            try {
                await http.put(`/market-segment/${payload.id}`, payload);
                
                payload.segment = segment;
                
                commit('editMarketSegment', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        //deleting segment // check
        async deleteSegment({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                const result = await http.delete(`/segment/${payload}`);
                if (result) {
                    commit('deleteSegment', payload)            
                    commit('setLoading', false)
                }
                else {
                    console.log('Deleting was not correct');
                }
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        //deleting market-segment
        async deleteMarketSegment({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                const result = await http.delete(`/market-segment/${payload}`);
                if (result) {
                    commit('deleteMarketSegment', payload)            
                    commit('setLoading', false)
                }
                else {
                    console.log('Deleting was not correct');
                }
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        //calculate segment actual_size
        async calculateActualSize({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            const game_id = payload.gameId;
            const round = payload.round;
            console.log(payload)

            try {
                const result = await http.get(`/market-segment/actualSize/${ game_id }?round=${round}`);
                console.log(result)
                if (result) {
                   const segments = await result.data 
                   commit('loadMarketSegments', segments)
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        //next round transition by game id & round
        async segmentTransition({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
    
            try {
                const result = await http.get(`/market-segment/transition/${payload.gameId}?round=${payload.round}`);
                if (result) {
                   const segments = await result.data 
                   commit('loadMarketSegments', segments)
                }                
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
    },
    getters: {
        segments(state) {
            return state.segments;
        },
        market_segments(state) {
            return state.market_segments;
        },
        DOMINANT_GENDER(state) {
            return state.DOMINANT_GENDER;
        },
        INCOME_RANGE(state) {
            return state.INCOME_RANGE;
        },
        EDUCATION(state) {
            return state.EDUCATION;
        },
        CIVIL_STATUS(state) {
            return state.CIVIL_STATUS;
        },
        WORKPLACE(state) {
            return state.WORKPLACE;
        },
        LIFESTYLE(state) {
            return state.LIFESTYLE;
        },
    }
}